import { sectionNameSelector } from '@lingoda/auth';
import { assert } from '@lingoda/utils';
import {
    type ApolloErrorHandler,
    useYearlyRecapAllSummaryQuery,
    useYearlyRecapAllSummarySuspenseQuery,
} from '@lingoda/graphql';
import { useSelector } from '@lingoda/hooks';

interface Params {
    onError?: ApolloErrorHandler;
    skip?: boolean;
}

export const useStoriesData = ({ onError, skip }: Params = {}) => {
    const { data, loading } = useYearlyRecapAllSummaryQuery({
        variables: {
            year: 2023,
        },
        onError,
        skip,
    });
    const storiesData = data ? data.studentYearlySummary : null;

    return { data: storiesData, loading };
};

export const useStoriesCachedData = () => {
    const sectionName = useSelector(sectionNameSelector);
    const { data } = useYearlyRecapAllSummarySuspenseQuery({
        variables: {
            year: 2023,
        },
    });
    const { studentYearlySummary } = data;
    assert(studentYearlySummary, 'studentYearlySummary should be cached now');
    assert(sectionName, 'sectionName should be defined');
    const learnedWordsCount = 0;

    return {
        data: {
            ...studentYearlySummary,
            learnedWordsCount,
            sectionName,
        },
    };
};
